import { axiosInstanceWebsite } from "../instance";
import { cachedRequest, clearCachedRequest } from "../../utils/requestCache";
import { decodeTokenService } from "../decodeTokenService";

const USER_SETTINGS_TTL_MS = 5 * 60_000;
const userSettingsCacheKey = () =>
    `user-settings:${decodeTokenService.getUserIdFromToken() || "anonymous"}`;

export const getUserSettings = async () => {
    return cachedRequest(userSettingsCacheKey(), USER_SETTINGS_TTL_MS, async () => {
        const response = await axiosInstanceWebsite.get(`/user/settings`, { timeout: 20_000 });
        return response.data;
    });
};

export interface UserSettingsPayloadInterface {
    country: string,
    currency: string,
    language: string,
    time_zone?: string,
    allow_market_update?: boolean,
};

export const upsertUserSettings = async (data: UserSettingsPayloadInterface) => {
    const response = await axiosInstanceWebsite.put(`/user/settings`, data);
    clearCachedRequest(userSettingsCacheKey());
    return response.data;
};
